import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';

/* ── NAV ICONS ── */
const IcHome = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M2 10.5L11 3l9 7.5V20H14v-6H8v6H2z" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);
const IcContact = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M4 3h4.5l2 5-2.5 2A13 13 0 0014 15.5l2-2.5 5 2V19a2 2 0 01-2 2A18 18 0 012 5a2 2 0 012-2z" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);
const IcContribute = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <circle cx="11" cy="11" r="8.5" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.5"/>
    <path d="M11 7v8M7 11h8" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);
const IcAbout = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <circle cx="11" cy="11" r="8.5" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.5"/>
    <path d="M11 10v6" stroke={active?"#C0202D":"#BBBBD0"} strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="11" cy="7" r="1" fill={active?"#C0202D":"#BBBBD0"}/>
  </svg>
);

const NAV = [
  { label:"Home",       Icon:IcHome , url:"/" },
  { label:"Contribute", Icon:IcContribute , url:"/contribution" },
  { label:"Contact",    Icon:IcContact , url:"/contact" },
  { label:"About",      Icon:IcAbout , url:"/aboutUs" },
];

const ACCENT = ["#FF416C","#4776E6","#11998E","#F7971E"];

export default function NavBar() {
    const [activeNav, setActiveNav] = React.useState(0);
    const path = useLocation().pathname;
    useEffect(()=>{
      const idx = NAV.findIndex(n=>n.url===path);
      if(idx>=0) setActiveNav(idx);
    },[path])
    
  return (
       <nav style={{
        position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",
        width:"100%",maxWidth:430,
        background:"rgba(255,255,255,0.90)",
        backdropFilter:"blur(28px) saturate(200%)",
        WebkitBackdropFilter:"blur(28px) saturate(200%)",
        borderTop:"1px solid rgba(180,180,230,0.28)",
        display:"flex",zIndex:300,
        boxShadow:"0 -6px 30px rgba(100,100,180,0.10)",
      }}>
        {NAV.map(({label,Icon, url},i)=>{
          const on=activeNav===i; const c=ACCENT[i];
          return (
            <Link to={url} key={i} className="nb" onClick={()=>setActiveNav(i)} style={{
              flex:1,padding:"10px 0 13px",border:"none",
              background:"transparent",cursor:"pointer",
              display:"flex",flexDirection:"column",alignItems:"center",gap:3,
              position:"relative",fontFamily:"inherit",
            }}>
              {on&&<>
                <div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:34,height:3,borderRadius:"0 0 5px 5px",background:`linear-gradient(90deg,${c},${ACCENT[(i+1)%4]})`,boxShadow:`0 2px 10px ${c}90`}}/>
                <div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:60,height:28,background:`radial-gradient(ellipse,${c}20,transparent 72%)`,pointerEvents:"none"}}/>
              </>}
              <Icon active={on}/>
              <span style={{fontSize:9,fontWeight:on?900:600,color:on?c:"#BBBBD0",letterSpacing:0.3,transition:"color 0.2s"}}>{label}</span>
            </Link>
          );
        })}
      </nav>
  )
}
